export const FETCH_ANNOUNCEMENTS = 'portal_compras/announcement/FETCH_ANNOUNCEMENTS'
export const SET_ANNOUNCEMENTS_ERROR = 'portal_compras/announcement/SET_ANNOUNCEMENTS_ERROR'
export const SET_ANNOUNCEMENTS_LIST = 'portal_compras/announcement/SET_ANNOUNCEMENTS_LIST'
export const SET_ANNOUNCEMENTS_IS_LOADING = 'portal_compras/announcement/SET_ANNOUNCEMENTS_IS_LOADING'
